import http from 'plugins/axios'

export default {
  //旧的账单接口
  // reqList(data) {
  //   return http.get({
  //     url: '/la/admin/transfer/list',
  //     data
  //   });
  // },
  //新账单接口
  //获取转账类型
  getTransferType() {
    return http.get({
      url: '/la/admin/public/transfer/type',
    })
  },
  reqList(data) {
    return http.get({
      url: `/la/admin/balance/bill/getInternalTransferRecordList`,
      data: { ...data, transferType: 0 },
    })
  },
  create(data) {
    return http.post({
      url: '/la/admin/transfer/create',
      data,
      dataType: 'form',
    })
  },
  transfer({ userId, coin, amount, type }) {
    return http.post({
      url: `/la/admin/public/transfer?userId=${userId}&coin=${coin}&amount=${amount}&type=${type}`,
    })
  },
  mockTransfer({ tenantId, userId, coin, amount, type }) {
    return http.post({
      url: `/la/admin/public/mock/transfer?tenantId=${tenantId}&userId=${userId}&coin=${coin}&amount=${amount}&type=${type}`,
    })
  },
  getCoinTypes() {
    return http.get({
      url: '/la/admin/coin/allDisplay',
    })
  },
}
